import Modal from '@components/modal'
import { FC, useState } from 'react'
import { useSelector } from 'react-redux'
import { Formik, Form } from 'formik'
import Column from '@components/column'
import Fields from '@components/fields'
import Button from '@components/button'
import { store, Actions } from '@store'
import { User } from '@apis'
import { AuthSchema } from '@validations'
interface QueueProps {
  visible: boolean
}

const Queue: FC<QueueProps> = ({ visible }) => {
  const { data: user } = useSelector((state: any) => state.user)
  const [loading, setLoading] = useState(false)
  const [initialValues] = useState({
    title: user?.infos?.queue?.title,
    noOfPatient: user?.infos?.queue?.noOfPatient,
    downtime: user?.infos?.queue?.downtime,
  })
  const submitHandler = async (values) => {
    setLoading(true)
    await User.queue({
      data: values,
    })
      .then(() => {
        store.dispatch(Actions.reset('modal'))
      })
      .catch(() => {})
    setLoading(false)
  }
  return (
    <Modal
      visible={visible}
      title="Create Queue"
      onClose={() => {
        store.dispatch(Actions.reset('modal'))
      }}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={submitHandler}
        enableReinitialize
        validationSchema={AuthSchema.queueValidationSchema}
      >
        {({ handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Column rowGap={20}>
                <Fields.Input
                  name="title"
                  label="Queue Title"
                  placeholder="Queue Title"
                />
                <Fields.Input
                  name="noOfPatient"
                  label="No Of Patient"
                  placeholder="No Of Patient"
                  type="number"
                />
                <Fields.Input
                  name="downtime"
                  label="Downtime in Between Patients"
                  placeholder="Downtime in Between Patients (In Minutes)"
                />
                <Button
                  title="Yes"
                  height={40}
                  styleButton="width:100%;"
                  loading={loading}
                  type="submit"
                />
              </Column>
            </Form>
          )
        }}
      </Formik>
    </Modal>
  )
}

export default Queue
